<template>
    <div id="ActivtyTask">
        <h1>Task Hareketleri</h1>
        <a-card class="activity-container">
            <div v-if="activities === null" class="empty-state">
                <p>Yükleniyor...</p>
            </div>
            <div v-else-if="activities && activities.length" class="activity-list">
                <a-card v-for="activity in activities" :key="activity._id" class="activity-item">
                    <div class="activity-header">
                        <div class="user-info">
                            <Avatar
                                v-if="activity.actor === 'user'"
                                :size="25"
                                :src="usersMap[activity.actorUser] && usersMap[activity.actorUser].gravatar"
                                :username="usersMap[activity.actorUser] && usersMap[activity.actorUser].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="usersMap[activity.actorUser] && usersMap[activity.actorUser].email"
                            />
                            <Avatar
                                v-if="activity.actor === 'chatbot'"
                                :username="'Chatbot'"
                                class="avatar"
                                :src="baseUrl().concat('static/img/chatbot-bg.png')"
                            />

                            <Avatar
                                v-if="activity.actor === 'system'"
                                :username="'System'"
                                class="avatar"
                                :src="baseUrl().concat('static/img/minilogo4.png')"
                            />
                            <span class="user-name" v-if="activity.actor === 'user'">
                                {{ (usersMap[activity.actorUser] && usersMap[activity.actorUser].name) || "Bilinmeyen Kullanıcı" }}
                            </span>
                            <span class="user-name" v-if="activity.actor === 'chatbot'">
                                ChatBot
                            </span>
                            <span class="user-name" v-if="activity.actor === 'system'">
                                System
                            </span>
                        </div>
                        <span class="activity-time">
                            {{ $moment(activity.updatedAt).fromNow() }}
                        </span>
                    </div>

                    <div class="activity-content" v-html="getActivityContent(activity)"></div>
                </a-card>
            </div>
            <div v-else>
                <p>Herhangi bir hareket bulunamadı.</p>
            </div>
        </a-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";

export default {
    name: "ActivtyTask",
    components: {
        Avatar,
    },
    props: {
        taskId: {
            type: String,
            required: true,
        },
        loadOnMount: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activities: null,
        };
    },
    computed: {
        ...mapState({
            usersMap: function(state) {
                return state.user.users.data.reduce(function(acc, user) {
                    acc[user._id] = user;
                    return acc;
                }, {});
            },
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
        }),
    },
    methods: {
        ...mapActions({
            getTaskActivities: "tasks/getTaskActivities",
        }),
        loadActivities() {
            if (!this.activities) {
                this.fetchActivities();
            }
        },
        async fetchActivities() {
            try {
                const activities = await this.getTaskActivities(this.taskId);
                this.activities = activities;
            } catch (error) {
                console.error("Error fetching activities:", error);
                this.activities = [];
            }
        },
        baseUrl: () => {
            if (document.currentScript) {
                let _documentUrl = document.currentScript.src.split("/");
                return _documentUrl[0] + "//" + _documentUrl[2] + "/";
            } else {
                return "/";
            }
        },
        getActivityContent(activity) {
            let user = this.usersMap[activity.actorUser]?.name || "Bilinmeyen Kullanıcı";
            if (activity.actor === "system") {
                user = "Sistem";
            } else if (activity.actor === "chatbot") {
                user = "ChatBot";
            }
            const task = activity.payload.name;
            const oldStage = activity.payload.oldStage;
            const newStage = activity.payload.newStage;
            const oldPriority = activity.payload.oldPriority;
            const newPriority = activity.payload.newPriority;
            const taskTitle = activity.payload.taskTitle || "Bilinmeyen Görev";
            const tags = activity.payload.tags?.join(", ");
            const ruleSource = activity.payload.ruleSource;
            const ruleInfo = ruleSource ? ` (<em>${ruleSource}</em> aracılığıyla)` : '';

            switch (activity.type) {
                case "task-created":
                    return this.$t("notification.taskCreated", { user, task }) + ruleInfo;
                case "task-stage-changed":
                    return this.$t("notification.taskStageChanged", { user, task, oldStage, newStage }) + ruleInfo;
                case "task-workflow-changed":
                    const oldWorkflowName = activity.payload.oldWorkflowName || "Bilinmeyen İş Akışı";
                    const newWorkflowName = activity.payload.newWorkflowName || "Bilinmeyen İş Akışı";
                    return `${user} kullanıcısı bu görevi "${oldWorkflowName}" iş akışından "${newWorkflowName}" iş akışına taşıdı${ruleInfo}.`;
                case "task-assigned-to-user":
                    return `<strong>${user}</strong> kullanıcısı, ${activity.payload.assignees.map(assignee => `<strong>${assignee}</strong>`).join(", ")} kullanıcısını <strong>"${taskTitle}"</strong> adlı göreve atadı${ruleInfo}.`;
                case "task-update-priority":
                    return this.$t("notification.taskPriorityUpdated", { user, oldPriority, newPriority, taskTitle }) + ruleInfo;
                case "task-added-tags":
                    return this.$t("notification.taskAddedTags", { user, taskTitle, tags }) + ruleInfo;
                case "task-removed-tags":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden şu etiketleri kaldırdı: <strong>${tags}</strong>${ruleInfo}.`;
                case "task-update-title":
                    return `<strong>${user}</strong> kullanıcısı görev başlığını <strong>"${activity.payload.oldTitle}"</strong> den <strong>"${activity.payload.newTitle}"</strong> olarak güncelledi${ruleInfo}.`;
                case "task-update-description":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin açıklamasını güncelledi${ruleInfo}.`;
                case "task-update-start-date":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin başlangıç tarihini <strong>"${activity.payload.oldStartDateFormatted}"</strong> den <strong>"${activity.payload.newStartDateFormatted}"</strong> olarak güncelledi${ruleInfo}.`;
                case "task-update-end-date":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin bitiş tarihini <strong>"${activity.payload.oldEndDateFormatted}"</strong> den <strong>"${activity.payload.newEndDateFormatted}"</strong> olarak güncelledi${ruleInfo}.`;
                case "task-update-owner":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin sahibini <strong>"${activity.payload.oldOwner}"</strong> den <strong>"${activity.payload.newOwner}"</strong> olarak değiştirdi${ruleInfo}.`;
                case "task-added-followers":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve şu takipçileri ekledi: <strong>${activity.payload.followers?.join(", ")}</strong>${ruleInfo}.`;
                case "task-removed-followers":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden şu takipçileri kaldırdı: <strong>${activity.payload.followers?.join(", ")}</strong>${ruleInfo}.`;
                case "task-added-collaborators":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve şu işbirlikçileri ekledi: <strong>${activity.payload.collaborators?.join(", ")}</strong>${ruleInfo}.`;
                case "task-update-checklist":
                    const addedItems = activity.payload.addedItems || [];
                    const removedItems = activity.payload.removedItems || [];
                    const completedItems = activity.payload.completedItems || [];
                    const uncompletedItems = activity.payload.uncompletedItems || [];

                    let checklistDetails = [];
                    if (addedItems.length > 0) checklistDetails.push(`Eklenen: ${addedItems.join(", ")}`);
                    if (removedItems.length > 0) checklistDetails.push(`Silinen: ${removedItems.join(", ")}`);
                    if (completedItems.length > 0) checklistDetails.push(`Tamamlanan: ${completedItems.join(", ")}`);
                    if (uncompletedItems.length > 0) checklistDetails.push(`Tamamlanmayan: ${uncompletedItems.join(", ")}`);

                    return `${user} kullanıcısı "${taskTitle}" adlı görevin kontrol listesini güncelledi. ${checklistDetails.join(". ")}${ruleInfo}`;
                case "task-added-subtask":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve <strong>${activity.payload.subtaskCount}</strong> alt görev ekledi: <strong>${activity.payload.subtasks?.join(", ")}</strong>${ruleInfo}.`;
                case "task-removed-subtask":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden <strong>${activity.payload.subtaskCount}</strong> alt görevi sildi: <strong>${activity.payload.subtasks?.join(", ")}</strong>${ruleInfo}.`;
                case "task-added-attachment":
                    return `${user} kullanıcısı "${taskTitle}" görevine ${activity.payload.attachmentCount} dosya ekledi: ${activity.payload.attachments?.join(", ")}${ruleInfo}.`;
                case "task-comment-added":
                    const commentPreview = activity.payload.comment ? activity.payload.comment.substring(0, 50) + (activity.payload.comment.length > 50 ? "..." : "") : "";
                    return `${user} kullanıcısı "${taskTitle}" görevine yorum ekledi: "${commentPreview}"${ruleInfo}`;
                case "task-comment-updated":
                    const oldCommentPreview = activity.payload.oldComment ? activity.payload.oldComment.substring(0, 30) + "..." : "";
                    const newCommentPreview = activity.payload.newComment ? activity.payload.newComment.substring(0, 30) + "..." : "";
                    return `${user} kullanıcısı "${taskTitle}" görevindeki yorumu düzenledi. Eski: "${oldCommentPreview}" → Yeni: "${newCommentPreview}"${ruleInfo}`;
                case "task-comment-deleted":
                    const deletedCommentPreview = activity.payload.comment ? activity.payload.comment.substring(0, 50) + (activity.payload.comment.length > 50 ? "..." : "") : "";
                    return `${user} kullanıcısı "${taskTitle}" görevinden yorum sildi: "${deletedCommentPreview}"${ruleInfo}`;
                case "task-completed":
                    return this.$t("notification.taskCompleted", { user, taskTitle }) + ruleInfo;
                case "task-archived":
                    return this.$t("notification.taskArchived", { user, taskTitle }) + ruleInfo;
                case "task-deleted":
                    return this.$t("notification.taskDeleted", { user, taskTitle }) + ruleInfo;
                case "task-restored":
                    return `${user} kullanıcısı "${taskTitle}" adlı görevi çöp kutusundan geri çıkardı${ruleInfo}.`;
                case "task-unarchived":
                    return `${user} kullanıcısı "${taskTitle}" adlı görevi arşivden geri çıkardı${ruleInfo}.`;
                default:
                    return `${activity.type} - ${taskTitle}`;
            }
        },
    },
};
</script>

<style lang="scss">
#ActivtyTask {
    .activity-container {
        max-height: 500px;
        overflow-y: auto;

        .empty-state {
            text-align: center;
            padding: 20px;
            color: rgba(0, 0, 0, 0.45);
        }

        .activity-list {
            display: grid;
            gap: 12px;

            .activity-item {
                border-radius: 10px !important;
                border: 1px solid #e8e8e8 !important;

                .activity-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;

                    .user-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        .user-name {
                            font-weight: 500;
                        }
                    }

                    .activity-time {
                        font-size: 0.8em;
                        color: rgba(0, 0, 0, 0.45);
                    }
                }

                .activity-content {
                    font-size: 0.9em;
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
    }
}
.ant-card-bordered {
    border: none !important;
}
</style>
